module.exports = __webpack_public_path__ + "img/shuishou.4c6d4d36.png";